import React from "react";
// Auto-installs an axios interceptor that keeps API requests same-origin when
// the user is on `www.` and the build baked in the non-www host (or vice
// versa). MUST be imported before any module that calls `axios.create(...)`.
import "@/lib/apiOriginShim";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";

// Initialise Sentry (no-op without REACT_APP_SENTRY_DSN or outside production).
initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
